import { cache } from 'react';

import { getFilteredCountries } from './getFilteredCountries';
import {
  getPreparedCategories,
  getActualBlogCategories,
} from './getPreparedCategories';

import type {
  ArticleFolders,
  DataSourceEntry,
  Locales,
} from '@monoimin/sb-types';

export const getArticleDatasources = cache(async function getArticleDatasources(
  folder: ArticleFolders,
  locale: Locales,
  site?: MiniSlug
) {
  const countriesPromise = getFilteredCountries(folder, locale);
  let categoriesPromise: Promise<DataSourceEntry[]> = Promise.resolve([]);

  if (folder === 'insider') {
    categoriesPromise = getPreparedCategories('insider', locale);
  }
  if (folder === 'blog') {
    categoriesPromise = getActualBlogCategories(locale, site);
  }

  return Promise.all([countriesPromise, categoriesPromise]);
});
